<template>
  <div class="app">
    <comhd @search="dosearch"></comhd>
    <div class="main">
      <md-scroll-view
          :scrolling-x="false"
          auto-reflow
          @end-reached="handleToEnd"
          @refreshing="handleToTop"
          ref="sc"
      >
        <md-scroll-view-refresh
            slot="refresh"
            slot-scope="{ scrollTop, isRefreshActive, isRefreshing }"
            :scroll-top="scrollTop"
            :is-refreshing="isRefreshing"
            :is-refresh-active="isRefreshActive"
        ></md-scroll-view-refresh>
            <md-tab-bar
                v-model="orderBy"
                :items="items"
                :maxLength="5"
            />
            <md-tab-bar
                v-model="typeBy"
                :items="fenlei"
                :maxLength="5"
            />

          <div class="zbList">
            <div class="zbItem" v-for="item of list" :key="item.id" @click="$router.push({name:'acdetail',query:{id:item.id}})">
              <div class="cover">
                <img :src="item.cover" alt="">
              </div>
              <div class="info">
                <div class="title">{{ item.title.slice(0,20) }}</div>
                <div class="infoitem"> 开始时间 {{item.sTime|format('YYYY-MM-DD')}}</div>
                <div class="detail">

                  <div class="author">{{ item.author }}</div>
                  <div class="time">{{item.addTime|format('YYYY-MM-DD')}}</div>
                </div>
              </div>
            </div>
          </div>
        <md-scroll-view-more
            slot="more"
            :is-finished="isFinished"
        >
        </md-scroll-view-more>
        </md-scroll-view>
      </div>
  </div>



</template>

<script>
export default {
  name: "zbList",
  data(){
    return {
      items: [
        // {name: '', label: '全部'},
        // {name: 1, label: '按时间'},
      ],
      subCates:[

      ],
      curCate:null,
      orderBy: 1,
      typeBy:'',
      list:[],
      page:1,
      count:0,
      isFinished:false,
      keyword:'',
      istuwen2:false,
      fenlei:[
        {name:'',label: '全部'},
        { name: 1, label: '展览' },
        { name: 2, label: '赛事' },
        { name: 3, label: '培训' },
        { name: 4, label: '演出' },
        { name: 5, label: '讲座' },
        { name: 6, label: '公益' },
      ]
    }
  },

  watch:{
    curCate(nv){
      this.isFinished = false;
      this.list = []
      this.getData();
      this.getCateInfo()
    },
    typeBy(nv){
      this.isFinished = false;
      this.list = []
      this.getData();
    }
  },
  created(){
    if(this.$route.query.big == 1) this.istuwen2 = true
  },
  mounted(){
    this.getData()
    // this.getSubCates()
    // this.getCateInfo()

  },
  methods:{

    async dosearch(res){
      this.keyword = res
      this.isFinished = false;
      this.page = 1;
      this.list = []
      this.getData()
    },

    async handleTabChange(){
      this.list = []
      this.page = 1;
      this.getData();
      this.isFinished = false
    },
    async getData(){
      if(this.isFinished)  return this.$toast.info('已经没有更多的了')
      let { cid } = this.$route.query
      let order = '';
      if(this.curCate) cid = this.curCate
      if(this.orderBy === 1) order=''
      if(this.orderBy === 2) order='byview'
      if(this.orderBy === 3) order='bytime'
      let res = await this.$api.post('/findActivity',{
        page:this.page,
        limit:10,
        title:this.keyword,
        type:this.typeBy,
        enable:1
      })
      const  { data,success}  = res.data;
      const { count,rows} = data
      if(success){
        this.count = count
        this.list = this.list.concat(rows)
        this.$refs.sc.finishLoadMore()
        if(this.list.length >= this.count) this.isFinished = true
      }

    },
    async handleToEnd(){
      if(!this.isFinished)  this.page++
      this.getData()

    },
    async handleToTop(){
      this.list = []
      this.page = 1;
      this.isFinished = false
      await this.getData()
      this.$refs.sc.finishRefresh()
    }
  }
}
</script>

<style scoped>

.main{
  height: 0;
  flex-grow: 1;
}
.infoitem{
  font-size: 16px;
  line-height: 1.5;
}
</style>
